import { Injectable } from '@angular/core';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { map, tap, catchError, take, timeout } from 'rxjs/operators';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsExportService {
  constructor(private analyticsService: AnalyticsService) {}

  export(query: string, filters: Record<string, any[]> | null, format: 'csv' | 'pdf'): Observable<void> {
    const filtersCopy = filters ? { ...filters } : {};

    const export$ =
      format === 'csv'
        ? this.analyticsService.exportToCSV(query, filtersCopy)
        : this.analyticsService.exportToPDF(query, filtersCopy);

    return export$.pipe(
      take(1),
      timeout(120_000),
      tap((blob: Blob) => {
        this.downloadBlob(blob, `${query}-${new Date().toISOString()}.${format}`);
      }),
      map(() => undefined),
      catchError((error) => {
        if (error instanceof TimeoutError) {
          console.error('Export timed out after 120s:', query);
        } else {
          console.error('Export error:', error);
        }
        return throwError(() => error);
      })
    );
  }

  private downloadBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
